import React, { useEffect, useRef, useState } from 'react'
import { MarkerPropsType } from './types'
import { useSelector } from 'react-redux'
import { InitialState } from '../../containers/AdminMapEditPage/types'

// Components
import Icon from '../Icon'
import Loading from '../Loading'

// Styles
import './styles.scss'

// Icons Default
import IconStart from './images/iconStart'
import IconFinish from './images/iconFinish'
import IconPopArrow from '../Marker/images/iconPopArrow'

const offsetIcons = {
  start: {
    top: 13.5,
    left: 15,
  },
  finish: {
    top: 13.5,
    left: 15,
  },
  circle: {
    top: 26.5,
    left: 26.5,
  },
  oval: {
    top: 31,
    left: 22.5,
  },
  rectangle: {
    top: 29,
    left: 20,
  },
  rounded_rectangle: {
    top: 26.5,
    left: 19.5,
  },
  rhombus: {
    top: 27,
    left: 27,
  },
  clover: {
    top: 26,
    left: 26,
  },
  hexagon: {
    top: 28.5,
    left: 28,
  },
  concave_cylinder: {
    top: 28.5,
    left: 21,
  },
}

export default ({
  id,
  onStart,
  type,
  color,
  x,
  y,
  indexNumber,
  lessonTitle,
  moduleTitle,
  onRemoveMarker,
}: MarkerPropsType) => {
  const [offsetPopOver, setOffsetPopOver] = useState<number>(0)

  const refContent = useRef<HTMLDivElement | null>(null)
  const popUpRef = useRef<HTMLDivElement | null>(null)

  const { isProcessMarkerId } = useSelector(
    (state: { adminMapEdit: InitialState }) => state.adminMapEdit
  )

  useEffect(() => {
    if (refContent.current) {
      setOffsetPopOver(refContent.current.offsetLeft)
    }
  }, [refContent])

  const widthWindow = document.body.clientWidth
  const popOverLeft = widthWindow - (offsetPopOver + 700) < 0
  const widthPopUp = popUpRef.current?.offsetWidth || 0

  const flagTypes = ['start', 'finish']

  const iconFlags = {
    start: <IconStart />,
    finish: <IconFinish />,
  }

  return (
    <div
      ref={refContent}
      onMouseDown={(event: any) => {
        event.target?.className !== 'admin__marker-remove' && !isProcessMarkerId
          ? onStart(
              id,
              refContent,
              event.clientX,
              event.clientY,
              offsetIcons[type]?.top,
              offsetIcons[type]?.left
            )
          : null
      }}
      className={'admin__marker'}
      style={{
        position: 'absolute',
        top: y - offsetIcons[type]?.top,
        left: x - offsetIcons[type]?.left,
      }}
    >
      <button
        className={'admin__marker-remove'}
        onClick={() => onRemoveMarker(id)}
      >
        x
      </button>
      <div className={'admin__marker-content'}>
        {isProcessMarkerId === id ? (
          <Loading
            color={'#FFF'}
            style={{ margin: 0 }}
            width={20}
            height={20}
          />
        ) : (
          <span className={'admin__marker-content-index'}>{indexNumber}</span>
        )}
      </div>
      {flagTypes.includes(type) ? (
        // @ts-ignore
        iconFlags[type]
      ) : (
        <Icon
          type={type}
          status={'default'}
          isFill={true}
          color={color || '#A3A3A3'}
          props={{
            width: offsetIcons[type]?.left * 2,
            height: offsetIcons[type]?.top * 2,
          }}
        />
      )}
      {!flagTypes.includes(type) ? (
        <div
          ref={popUpRef}
          className={popOverLeft ? 'marker__popover left' : 'marker__popover'}
          style={{
            top: '50%',
            transform: 'translateY(-50%)',
            left: popOverLeft
              ? -widthPopUp - 13
              : offsetIcons[type]?.left * 2 + 13,
          }}
        >
          <div
            className={
              popOverLeft
                ? 'marker__popover-arrow left'
                : 'marker__popover-arrow'
            }
          >
            <IconPopArrow />
          </div>
          <div>
            <div
              className={'marker__popover-header'}
              style={{ marginBottom: 5 }}
            >
              <span
                className={'circle'}
                style={{ background: color || '#A3A3A3' }}
              />
              <span className={'title'}>{moduleTitle}</span>
            </div>
            <div className={'marker__popover-info'}>
              <span className={'name'}>Урок:</span>
              <span className={'title'}>{lessonTitle}</span>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  )
}
